export enum RulesEngineRuleScopeEnum {
    Hidden = 0,
    Internal = 1,
    Customer = 2
}